
import { useTranslation } from 'react-i18next';

export default function PositioningSection() {
  const { t } = useTranslation();

  const positioningPoints = [
    {
      icon: 'ri-handshake-line',
      titleKey: 'long_term_partner',
      descKey: 'long_term_partner_desc'
    },
    {
      icon: 'ri-focus-3-line',
      titleKey: 'result_oriented',
      descKey: 'result_oriented_desc'
    },
    {
      icon: 'ri-settings-2-line',
      titleKey: 'executable_solutions',
      descKey: 'executable_solutions_desc'
    },
    {
      icon: 'ri-customer-service-2-line',
      titleKey: 'professional_service',
      descKey: 'professional_service_desc'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('positioning_title')}
          </h2>
          <p className="text-lg text-gray-600 mb-2">{t('positioning_subtitle')}</p>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('positioning_desc')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {positioningPoints.map((point, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 text-center group">
              <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${point.icon} text-white text-2xl`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {t(point.titleKey)}
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                {t(point.descKey)}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl p-8">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              {t('why_choose_us_partner')}
            </h3>
            <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
              {t('why_choose_us_partner_desc')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
